import React, { ChangeEvent, FocusEvent } from 'react';

interface InputProps {
  label?: string;
  type?: 'text' | 'email' | 'password' | 'number' | 'datetime-local';
  placeholder?: string;
  required?: boolean;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void; // Typing onBlur
  error?: boolean;
  helperText?: string;
}

export const FloatingLabelInput: React.FC<InputProps> = ({
  label,
  type = 'text',
  placeholder = '',
  required = false,
  value,
  onChange,
  onBlur,
  error = false,
  helperText = '',
}) => {
  return (
    <div className='w-full'>
      { label && (
        <label className='block mb-1 text-[11px] font-semibold text-slate-500 uppercase tracking-wider ml-0.5'>
          { label } { required && <span className='text-red-500'>*</span> }
        </label>
      ) }

      <input
          type={type}
          value={value}
          onChange={onChange}
          onBlur={onBlur} // Corrected onBlur type
          placeholder={placeholder}
          required={required}
          className={`w-full h-9 px-3 text-[13px] bg-white border rounded-lg outline-none transition-all duration-200
          ${
            error
              ? 'border-red-400 focus:ring-4 focus:ring-red-500/10 focus:border-red-500'
              : 'border-slate-200 hover:border-slate-300 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10'
          } 
          placeholder:text-slate-400 placeholder:text-xs`}
      />

      { error && helperText && (
        <p className='mt-1 text-[11px] text-red-500 font-medium ml-0.5'>
          { helperText }
        </p>
      ) }
    </div>
  );
};
